import { useAuth } from "@/lib/auth";
import { useAsync } from "@/hooks/useAsync";
import { supabase } from "@/lib/supabase";
import { CommentSection } from "./CommentSection";
import { GuestNameModal } from "./GuestNameBanner";

/**
 * Lazy-loaded wrapper that resolves playlist context from a share token
 * and renders the guest name modal + comment section.
 * Kept in a separate chunk so its imports don't block video loading.
 */
export function SharedPlaylistComments({
  playlistToken,
}: {
  playlistToken: string | null;
}) {
  const { user } = useAuth();

  const { data: shareInfo } = useAsync(
    async () => {
      const result = await supabase
        .from("playlist_shares")
        .select("playlist_id(id, user_id)")
        .eq("invitation_token", playlistToken!)
        .single();
      return result as {
        data: {
          playlist_id: { id: string; user_id: string | null } | null;
        } | null;
        error: { message: string } | null;
      };
    },
    playlistToken ? [playlistToken] : null,
  );

  const playlistId = shareInfo?.playlist_id?.id ?? null;
  const organizerUserId = shareInfo?.playlist_id?.user_id ?? null;

  return (
    <>
      {!user && <GuestNameModal />}
      <CommentSection
        playlistId={playlistId}
        guestToken={playlistToken}
        guestTokenType="playlist"
        organizerUserId={organizerUserId}
        className="mt-2 px-[clamp(1rem,3vw,3rem)] pb-10"
      />
    </>
  );
}
